<template>
  <div class="r-product-detail-title">
    <h1 class="title_font2">
      {{ product && product.post_title }}
    </h1>
    <v-proDelStart
      v-if="show_comment_score && comment"
      :average_rating="product.average_rating"
      :review_count="product.review_count"
    ></v-proDelStart>
    <h3 class="price_text">
      <v-selectprice
        :currency_style="currency_style"
        :price="(computed_price && computed_price.price) || now_variant.price"
        :regular_price_num="
          (computed_price && computed_price.regular_price) ||
          (now_variant.price - 0 < now_variant.regular_price - 0
            ? now_variant.regular_price
            : 0)
        "
        :disable_select="
          theme == 'showtime' || theme == 'vogue' || theme == 'athena'
            ? 'true'
            : !show_currency_selector
        "
        :country="
          theme == 'showtime' || theme == 'vogue' || theme == 'athena'
            ? !show_currency_selector
              ? ''
              : $store.state.pricetype
            : ''
        "
        :appendToBody="false"
        :regularFontSize="theme == 'athena' ? 14 : null"
        :fontSize="theme == 'athena' ? 14 : null"
      ></v-selectprice>
      <div
        class="tag"
        :class="{ 'tag-1': theme == 'athena' }"
        v-if="theme == 'athena' && computed_price && computed_price.percentage"
      >
        {{ computed_price.percentage }}% off
      </div>
    </h3>
  </div>
</template>

<script>
import vProDelStart from "../../../../../js/components/view/comments/proDelStart.vue";
export default {
  props: [
    "product",
    "show_comment_score",
    "comment",
    "currency_style",
    "now_variant",
    "theme",
    "show_currency_selector",
    "computed_price",
  ],
  components: {
    vProDelStart,
  },
};
</script>

<style lang="scss" scoped>
.tag-1 {
  display: inline-block;
  font-size: 14px;
  line-height: 26px;
  width: 80px;
  background: #222222;
  border-radius: 13px;
  text-align: center;
  color: #fff;
  vertical-align: text-bottom;
}
.r-product-detail-title {
  position: relative;
  background: none;
  padding: 6px 24px;
  &::v-deep .show_comment_score {
    margin-top: 16px;
  }
  .price_text {
    margin-bottom: 0;
    font-weight: bold;
    .product_price_number_compare {
      font-size: 1.06rem;
      color: #b89797;
      margin-left: 6px;
      text-decoration: line-through;
    }
  }
}
@media screen and (max-width: 768px) {
  .tag-1 {
    font-size: 12px;
    line-height: 20px;
    width: 60px;
    border-radius: 10px;
  }
  .r-product-detail-title {
    padding: 24px 0 20px 0;
    h1 {
      font-size: 15px;
    }
  }
}
</style>